import { urlize } from '@common/helpers/url';
import Footer from '@react/shared/components/Footer';
import { GoogleSearchSuggestion } from '@sly/core/api/types/search';
import Helmet from 'next/head';
import { useRouter } from 'next/router';
import { StrictMode, useEffect, useRef } from 'react';
import AgentsContent from 'sly/agentsPage/components/AgentsContent';
import AgentsHeader from 'sly/agentsPage/components/AgentsHeader';
import { host } from 'sly/config';
import { useLocation } from 'sly/lib/react-router';
import { eventNames, pageNames, useEvents } from 'sly/services/events';

function AgentsPage() {
  const location = useLocation();
  const { events } = useEvents();
  const router = useRouter();
  useEffect(() => {
    events.page(pageNames.Agents, {});
  }, []);

  const heroRef = useRef<HTMLDivElement>(null);
  const onLocationSearch = (result: GoogleSearchSuggestion) => {
    events.track(eventNames.FormSubmitted, {
      form: 'search',
      location: 'agents search',
      values: {
        search: result.displayText,
      },
    });

    const [city, state] = result.name.replace(/\d+/g, '').split(', ');
    router.push(`/agents/region/${urlize(city)}-${state}`);
  };
  return (
    <StrictMode>
      <Helmet>
        <link rel='canonical' href={`${host}${location.pathname}`} />
        <title>Find Senior Living Advisors | Seniorly Partner Agents</title>
        <meta
          name='description'
          content='Talk to our senior living advisors and partner agents at Seniorly. Connect with a local senior living advisor for personalized senior housing support!'
        />
      </Helmet>
      <AgentsHeader onLocationSearch={onLocationSearch} heroRef={heroRef} />
      <AgentsContent heroRef={heroRef} />
      <Footer />
    </StrictMode>
  );
}

export default AgentsPage;
